import store from '../Store/configureStore';

export const searchFilterService = {
    objectFilter,
	orderFilter,
	userFilter,
	customerFilter
};

function objectFilter(obj, predicate){ 
			return Object.keys(obj)
					.filter( key => predicate(obj[key]) )
					.reduce( (res, key) => (res[key] = obj[key], res), {} );
}

//function arrayFilter(array, predicate){
//	return array.filter( index => predicate(array[index]) );
//}

const states = ["NEW", "READY", "FORMAT_QA", "COMPLETED"]

function orderFilter(order) {
	const state = store.getState();
//		console.log("orderFilter");
//		console.log(order.user);
//		console.log(state.users[order.user].customer);
//		console.log(state.customers[state.users[order.user].customer].name);
	return (
		// CUSTOMER
		state.customers[state.users[order.user].customer].name.toUpperCase().includes(state.search.searchString.toUpperCase()) ||
		// DOC Filename
		order.phase[0].document.filename.toUpperCase().includes(state.search.searchString.toUpperCase()) || 
		// LANGUAGE-PAIR
		state.languagePairs[order.langPair].code.toUpperCase().includes(state.search.searchString.toUpperCase()) ||
		// USER (trad)
		order.phase.reduce(cercaResponsable,"").toUpperCase().includes(state.search.searchString.toUpperCase()) ||
		// CODE
		order.code.toUpperCase().includes(state.search.searchString.toUpperCase()) ||
		// ESTAT
		order.state.toUpperCase()===state.search.searchString.toUpperCase() )
}

function userFilter(user){
	const state = store.getState();
	return (user.username.toUpperCase().includes(state.search.searchString.toUpperCase()) ||
		(user.customer && state.customers[user.customer] && state.customers[user.customer].name.toUpperCase().includes(state.search.searchString.toUpperCase()) ))
}

function customerFilter(customer){
	const state = store.getState();
	return (customer.name.toUpperCase().includes(state.search.searchString.toUpperCase()));
}

function cercaResponsable(acum, value){
	const state = store.getState();
	if(value && (value.type=="TRANSLATION" || value.type=="PROOF_PRINTING")){
		if(value.user!==null && state.users[value.user]){
			//acum = value.user.username;
			acum = state.users[value.user].username;
		}
	}
	return acum;
}
